import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import ApplicationTable from "./ApplicationTable";
import { getApplications } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const RaiseQueryMISMenu = () => {
    const [selectedAction, setSelectedAction] = useState("All");
    const userDetails = useSelector((state:any)=>state.auth.userDetails)
    const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
     const language = useSelector((state:any)=>state.auth.language);
    
      
    const statusOptions = [
          { value: "all_raiseQuery", label: "All Application" },  
        { value: "clerkAfterRejectionAction", label: "Query Raised" },    
      
    ];


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list} - Raise Query</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <ApplicationTable status={statusOptions} navigateTo="/mis-raise-query" />
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
        </>
    );
};

export default RaiseQueryMISMenu;
